// extracted by mini-css-extract-plugin
export default {"containerWrap":"ExtraCols2_containerWrap__X84dh","container":"ExtraCols2_container__CQjzz"};